/* Autohobby forside-refresh — delt JS. Idempotent: kan lastes flere ganger. */
(function () {
  if (window.__ahForside) { window.__ahForside.initAll(); return; }
  var AH = window.__ahForside = { inited: new WeakSet() };

  AH.reveal = function (root) {
    var els = (root || document).querySelectorAll('.ah-rv:not(.ah-in)');
    if (!('IntersectionObserver' in window)) { Array.prototype.forEach.call(els, function(e){e.classList.add('ah-in');}); return; }
    if (!AH.io) {
      AH.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('ah-in'); AH.io.unobserve(en.target); } });
      }, { threshold: 0.1 });
    }
    Array.prototype.forEach.call(els, function (el) { AH.io.observe(el); });
  };

  AH.rails = function (root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.ah-rail-btn'), function (btn) {
      if (AH.inited.has(btn)) return; AH.inited.add(btn);
      btn.addEventListener('click', function () {
        var rail = document.getElementById(btn.getAttribute('data-rail'));
        if (rail) rail.scrollBy({ left: rail.clientWidth * 0.8 * parseFloat(btn.getAttribute('data-dir')), behavior: 'smooth' });
      });
    });
  };

  AH.hero = function (root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.ah-hero'), function (hero) {
      if (AH.inited.has(hero)) return; AH.inited.add(hero);
      var slides = hero.querySelectorAll('.ah-slide');
      if (slides.length < 2) { var v0 = hero.querySelector('.ah-slide video'); if (v0) v0.play().catch(function(){}); return; }
      var dotsWrap = hero.querySelector('.ah-dots');
      var cur = 0, timer;
      var dots = [];
      Array.prototype.forEach.call(slides, function (s, i) {
        var d = document.createElement('button');
        d.setAttribute('aria-label', 'Gå til slide ' + (i + 1));
        if (i === 0) d.classList.add('ah-on');
        d.addEventListener('click', function () { go(i); restart(); });
        dotsWrap.appendChild(d); dots.push(d);
      });
      function go(i) {
        cur = (i + slides.length) % slides.length;
        Array.prototype.forEach.call(slides, function (s, j) {
          s.classList.toggle('ah-on', j === cur);
          var v = s.querySelector('video');
          if (v) { if (j === cur) { v.play().catch(function(){}); } else { v.pause(); } }
        });
        dots.forEach(function (d, j) { d.classList.toggle('ah-on', j === cur); });
      }
      function restart() { clearInterval(timer); timer = setInterval(function () { go(cur + 1); }, 6500); }
      var prev = hero.querySelector('.ah-hprev'), next = hero.querySelector('.ah-hnext');
      if (prev) prev.addEventListener('click', function () { go(cur - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(cur + 1); restart(); });
      restart();
      var ensure = function () { var v = slides[cur].querySelector('video'); if (v && v.paused) v.play().catch(function(){}); };
      document.addEventListener('visibilitychange', ensure);
      window.addEventListener('pointerdown', ensure, { once: true });
      ensure();
    });
  };

  AH.trustpilot = function (root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-ah-tp]'), function (sec) {
      if (AH.inited.has(sec)) return; AH.inited.add(sec);
      var bu = sec.getAttribute('data-bu'), tmpl = sec.getAttribute('data-tmpl');
      if (!bu || !tmpl) return;
      var esc = function (s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); };
      var STAR = '<svg viewBox="0 0 24 24"><path d="M12 17.3 6.2 21l1.6-6.6L2.5 9.9l6.8-.55L12 3l2.7 6.35 6.8.55-5.3 4.5L17.8 21z"/></svg>';
      var starRow = function (n) { var h = '<span class="ah-stars">'; for (var i = 1; i <= 5; i++) h += '<i' + (i > n ? ' class="ah-off"' : '') + '>' + STAR + '</i>'; return h + '</span>'; };
      var MND = ['jan','feb','mar','apr','mai','jun','jul','aug','sep','okt','nov','des'];
      fetch('https://widget.trustpilot.com/trustbox-data/' + tmpl + '?businessUnitId=' + bu + '&locale=nb-NO&reviewsPerPage=8&reviewStars=4%2C5&reviewLanguages=no')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var tot = d.businessUnit && d.businessUnit.numberOfReviews && d.businessUnit.numberOfReviews.total;
          var totEl = sec.querySelector('[data-ah-tp-total]');
          if (tot && totEl) totEl.textContent = tot + ' omtaler';
          var revs = (d.reviews || []).filter(function (r) { return r.stars >= 4; }).slice(0, 8);
          if (!revs.length) return;
          var rail = sec.querySelector('.ah-tp-rail');
          rail.innerHTML = revs.map(function (rv) {
            var dt = new Date(rv.createdAt);
            var ver = rv.verification && rv.verification.isVerified;
            return '<div class="ah-tp-card">' + starRow(rv.stars) + '<h4>' + esc(rv.title) + '</h4><p>' + esc(rv.text) + '</p>' +
              '<span class="ah-tp-who"><b>' + esc(rv.consumer && rv.consumer.displayName) + '</b><span>' + dt.getDate() + '. ' + MND[dt.getMonth()] + '</span></span>' +
              (ver ? '<span class="ah-tp-badge">✓ Verifisert kjøp</span>' : '') + '</div>';
          }).join('');
        }).catch(function () {});
    });
  };

  AH.elbildata = function (root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-ah-ebd]'), function (sec) {
      if (AH.inited.has(sec)) return; AH.inited.add(sec);
      var api = sec.getAttribute('data-api');
      if (!api) return;
      var MND = ['januar','februar','mars','april','mai','juni','juli','august','september','oktober','november','desember'];
      var fmt = function (n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
      fetch(api).then(function (r) { return r.json(); }).then(function (s) {
        var rader = (s.modelltabell || []).slice().sort(function (a, b) { return (b.mnd || 0) - (a.mnd || 0); }).slice(0, 5);
        if (!rader.length) return;
        var m = sec.querySelector('.ah-mnd');
        if (m) m.textContent = 'i ' + MND[new Date().getMonth()];
        sec.querySelector('[data-ah-ebd-liste]').innerHTML = rader.map(function (r, i) {
          var merke = String(r.merke || '');
          merke = merke.charAt(0).toUpperCase() + merke.slice(1).toLowerCase();
          return '<div class="ah-ebd-row' + (i === 0 ? ' ah-first' : '') + '"><span class="ah-nr">' + (i + 1) + '</span><span class="ah-name">' + merke + ' ' + String(r.modell || '') + '</span><span class="ah-cnt">' + fmt(r.mnd || 0) + '<small>stk</small></span></div>';
        }).join('');
      }).catch(function () {});
    });
  };

  AH.wolve = function () {
    if (AH._wolveBound) return;
    AH._wolveBound = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href="#ah-wolve-signup"]') : null;
      if (!a) return;
      e.preventDefault();
      var t = document.querySelector('.wolve-vipps-signup-container, [class*="wolve-signup"], [class*="wolve-tab"]');
      if (t) { t.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      else { window.location.href = '/pages/medlemsklubb'; }
    });
  };

  AH.initAll = function (root) { AH.reveal(root); AH.rails(root); AH.hero(root); AH.trustpilot(root); AH.elbildata(root); AH.wolve(); };

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { AH.initAll(); }); } else { AH.initAll(); }
  document.addEventListener('shopify:section:load', function (e) { AH.initAll(e.target); });
})();
